import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetClinicPartnerActivePatientsArgs } from "../schemas/dashboard";

const getClinicPartnerActivePatientsQueryKey = (args: GetClinicPartnerActivePatientsArgs) =>
  ["getClinicPartnerActivePatients", args] as const;

export const useGetClinicPartnerActivePatients = (args: GetClinicPartnerActivePatientsArgs) => {
  const client = useApiClient();

  return useQuery(getClinicPartnerActivePatientsQueryKey(args), () => client.getClinicPartnerActivePatients(args));
};
